export class Book {
  CompanyID: string;
  StoreNo:string;
  ResDateS:string;
  ResDateE:string;
  RoomType:string;
  PetNo:string;
  SignPath: string;
}